import {Injectable, Injector} from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '../business/auth.service';
import * as Models from '../../../models/index';
import {BusinessService} from '../business.service';

@Injectable()
export class AppInitService {

    constructor(private injector: Injector, private httpClient: HttpClient, private authService: AuthService, private router: Router) {
        this.checkLogoutAction();
    }

    getSettings(): Promise<any> {
        // console.log("App Init !");
        if ((!this.authService.accessToken || this.authService.isTokenExpired) && window.location.pathname !== '/') {
            const url = window.location.pathname;
            localStorage.setItem(Models.CE.StorageKeys.redirectPathname, url);
            window.location.assign('/');
            return;
        } else {
            return new Promise((resolve, reject) => {
                if (!this.authService) {
                    // tslint:disable-next-line:max-line-length
                    (window as any).location = '/error.html?errorText=' + encodeURIComponent('Authentication service cannot be initialized.');
                    resolve(false);
                }

                this.authService
                    .authorizeUser()
                    .then((isTokenAcquired) => {
                        if (!isTokenAcquired) {
                            this.authService.login();
                            return;
                        } else {
                            const savedPathname = localStorage.getItem(Models.CE.StorageKeys.redirectPathname);
                            if (savedPathname) {
                                localStorage.removeItem(Models.CE.StorageKeys.redirectPathname);
                                this.router.navigate([`${savedPathname}`]);
                            }

                            resolve(true);
                        }
                    })
                    .catch((err) => {
                        resolve(true);
                    });
            });
        }
    }

    private checkLogoutAction(): void {
        if (localStorage.getItem(Models.CE.StorageKeys.logoutRedirect)) {
            localStorage.removeItem(Models.CE.StorageKeys.logoutRedirect);
            this.authService.doLogout();
        }
    }
}
